// extracted by mini-css-extract-plugin
export default {"mCard":"wD-z","image":"xD-z","imageNoBackground":"yD-z","imageHasCategory":"zD-z","fullWidth":"AD-z"};